import React from 'react';
import { graphql } from 'gatsby';
import classnames from 'classnames';
import { getImageDimensions } from '@sanity/asset-utils';

import Pancake from './Pancake';
import Container from '../Container';
import PancakeIntro from '../PancakeIntro';
import Card from '../Card';

import './Logos.scss';

const Logos = (props) => {
  const { title, text, logos, theme, useMarquee } = props;

  return (
    <Pancake className="PancakeLogos" theme={theme}>
      <Container>
        {(title || text) && <PancakeIntro title={title} text={text} />}
        {logos && !useMarquee && <LogosGroup {...props} />}
        {logos && useMarquee && (
          <div className="PancakesLogosMarquee">
            <LogosGroup {...props} />
            <LogosGroup {...props} />
          </div>
        )}
      </Container>
    </Pancake>
  );
};

const LogosGroup = ({
  useMarquee,
  logos,
  showCompanyName,
  roundedLogos,
  wrapLogosInCards,
  useLogomarkVersion,
}) => {
  return (
    <div
      className={classnames(
        'PancakeLogosGrid',
        wrapLogosInCards && 'PancakeLogosGridWithCards',
        roundedLogos && 'PancakeLogosGridRounded',
        useMarquee && 'PancakeLogosGridMarquee'
      )}
    >
      {logos.map((logo) => {
        const link = logo.externalLink ? logo.externalLink : logo.logo?.website;
        const logoSource =
          useLogomarkVersion && logo.logo?.logomarkDark?.asset?.url
            ? logo.logo?.logomarkDark?.asset?.url
            : logo.logo?.logoFullColorDark?.asset?.url;

        const { width, height } = getImageDimensions(logoSource);
        if (wrapLogosInCards) {
          return (
            <Card theme="Light" clickable>
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className={classnames(
                  'PancakeLogosLogo',
                  useLogomarkVersion && 'PancakeLogosLogomark',
                  roundedLogos && 'PancakeLogosLogoRounded'
                )}
              >
                <img
                  src={logoSource}
                  loading="lazy"
                  alt={logo.logo?.name}
                  width={width}
                  height={height}
                />
                {showCompanyName && logo.logo?.name}
              </a>
            </Card>
          );
        }

        return (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className={classnames(
              'PancakeLogosLogo',
              roundedLogos ? 'PancakeLogosLogoRounded' : ''
            )}
          >
            <img
              src={logoSource}
              loading="lazy"
              alt={logo.logo?.name}
              width={width}
              height={height}
            />
            {showCompanyName && logo.logo?.name}
          </a>
        );
      })}
    </div>
  );
};

export const query = graphql`
  fragment SanityPancakeLogos on SanityLogos {
    _key
    _type
    pancakeIntro {
      pancakeTitle
      pancakeText
    }
    logos {
      logo {
        website
        name
        logoFullColorDark {
          asset {
            url
          }
        }
        logomarkDark {
          asset {
            url
          }
        }
      }
      externalLink
    }
    showCompanyName
    roundedLogos
    useLogomarkVersion
    wrapLogosInCards
    useMarquee
    theme
  }
`;

export default Logos;
